import React from 'react';
import { ActionBar, DeleteDialog, FormDialog } from './components';
import type { ThongTinDoanhNghiepInput } from '@/types/schemas';
import { useFormState, useThongTinDoanhNghiep } from './hooks';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { getDataTableColumns } from './cols-definition';

export default function ThongTinNopThue() {
  const {
    showForm,
    showDelete,
    formMode,
    selectedObj,
    selectedRowIndex,
    isCopyMode,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useFormState();

  const { businessInfo, isLoading, addBusinessInfo, updateBusinessInfo, deleteBusinessInfo } = useThongTinDoanhNghiep();

  const handleFormSubmit = async (data: ThongTinDoanhNghiepInput) => {
    try {
      if (formMode === 'add') {
        await addBusinessInfo(data);
        handleCloseForm();
        clearSelection();
      } else if (formMode === 'edit' && selectedObj) {
        await updateBusinessInfo(selectedObj.uuid, data);
        handleCloseForm();
        clearSelection();
      }
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };

  const tables = [
    {
      name: '',
      rows: businessInfo,
      columns: getDataTableColumns()
    }
  ];

  return (
    <div className='flex h-screen flex-col lg:overflow-hidden'>
      <div className='w-full'>
        <ActionBar
          onAddClick={handleAddClick}
          onEditClick={handleEditClick}
          onDeleteClick={handleDeleteClick}
          onCopyClick={handleCopyClick}
          onViewClick={handleViewClick}
          // onFixedColumnsClick={handleFixedColumnsClick}
          // onRefreshClick={handleRefreshClick}
          onExportClick={() => {}}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          loading={isLoading}
        />
      </div>

      {showDelete && (
        <DeleteDialog
          open={showDelete}
          onClose={handleCloseDelete}
          selectedObj={selectedObj}
          deleteKhuVuc={deleteBusinessInfo}
          clearSelection={clearSelection}
        />
      )}

      {showForm && (
        <FormDialog
          open={showForm}
          onClose={handleCloseForm}
          onSubmit={handleFormSubmit}
          onAddButtonClick={handleAddClick}
          onEditButtonClick={handleEditClick}
          onDeleteButtonClick={handleDeleteClick}
          onCopyButtonClick={handleCopyClick}
          formMode={formMode}
        />
      )}
    </div>
  );
}
